import React from 'react';
import { LuCircleCheck, LuChevronRight } from 'react-icons/lu';

// "Para resolver hoy" del Inicio (27-oct-2026): un número grande por cosa que pide una decisión, con el
// nombre cuando es una sola. Cada uno abre Trabajos ya filtrado. Lo que no apura (presupuestos viejos,
// clientes para ofrecer, stock) va abajo en una línea, sin ocupar lugar.
const TONO = {
    rojo: 'border-[var(--alerta)] bg-[var(--alerta-bg)] [&_b]:text-[var(--alerta-tx)]',
    ambar: 'border-black/[0.06] dark:border-white/[0.06] bg-card [&_b]:text-[#B45309] dark:[&_b]:text-[#F0A500]',
    azul: 'border-[#3B5BDB]/50 bg-[rgba(59,91,219,0.10)] [&_b]:text-[#3B5BDB] dark:[&_b]:text-[#93B4FF]',
    gris: 'border-black/[0.06] dark:border-white/[0.06] bg-card [&_b]:text-ink',
};

export default function ResolverHoy({ items, extras = [] }) {
    if (!items.length && !extras.length) {
        return (
            <div className="flex items-center gap-2 px-3.5 py-3 rounded-2xl bg-card border border-black/[0.06] dark:border-white/[0.06] text-body text-secondary">
                <LuCircleCheck size={17} className="text-[var(--etapa-listo)] shrink-0" /> Nada para resolver. Todo al día.
            </div>
        );
    }
    return (
        <div className="space-y-2">
            {items.length > 0 && (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                    {items.map(a => (
                        <button key={a.id} type="button" onClick={a.onClick}
                            className={`${a.ancho ? 'col-span-2 flex-row items-center gap-3' : 'flex-col gap-0.5'} flex text-left px-3.5 py-3 rounded-2xl border active:scale-[0.98] ${TONO[a.tono] || TONO.gris}`}>
                            <b className="text-[26px] leading-none font-black">{a.n}</b>
                            <span className="text-body font-bold text-ink leading-snug">
                                {a.texto}
                                {a.detalle && <span className="block text-caption font-bold text-secondary truncate">{a.detalle}</span>}
                            </span>
                            {a.ancho && <LuChevronRight size={16} className="ml-auto text-muted shrink-0" />}
                        </button>
                    ))}
                </div>
            )}
            {extras.length > 0 && (
                <p className="px-1 text-caption text-muted leading-relaxed">
                    También: {extras.map((e, i) => (
                        <React.Fragment key={e.id}>
                            {i > 0 && ' · '}
                            <button type="button" onClick={e.onClick} className="font-bold text-secondary underline underline-offset-2">{e.texto}</button>
                        </React.Fragment>
                    ))}
                </p>
            )}
        </div>
    );
}
